module.exports = __webpack_public_path__ + "pa.22a480141c15563aa0b8.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/pa.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/pa.svg
// module chunks = styles